/**
 * Strips a phone number down to digits only for use in a `tel:` URI.
 *
 * Browsers and mobile OS phone dialers accept bare digits in `tel:` links.
 * Formatting characters (parentheses, hyphens, spaces) in a `tel:` href are
 * technically non-standard and can cause issues on some platforms.
 *
 * @example
 * formatPhoneForTel("(555) 123-4567") // "5551234567"
 * formatPhoneForTel("555.123.4567")   // "5551234567"
 * formatPhoneForTel("5551234567")     // "5551234567"
 */
function formatPhoneForTel(phone: string): string {
  return phone.replace(/\D/g, "");
}

export { formatPhoneForTel };
